var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClickup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#clickup_svg__a)",
  d: "m5 49.17 9.84-7.542c5.227 6.823 10.786 9.971 16.967 9.971s11.548-3.11 16.543-9.879l9.98 7.358C51.127 58.84 42.173 64 31.807 64S12.435 58.875 5 49.17"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#clickup_svg__b)",
  d: "M31.774 16.403 14.257 31.499l-8.095-9.393L31.812 0 57.26 22.12l-8.134 9.36z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "clickup_svg__a",
  x1: 5,
  x2: 58.33,
  y1: 52.814,
  y2: 52.814,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8930FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#49CCF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clickup_svg__b",
  x1: 6.162,
  x2: 57.26,
  y1: 15.747,
  y2: 15.747,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF02F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC800"
})))));
export default SvgClickup;